export default __webpack_public_path__ + "static/media/1280px-Tmux_logo.svg.02162ffc.png";